exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/competancy/question-bank-add-new-qa-modal/question-bank-add-new-qa-modal.component.scss
// module id = ../../../../../src/app/competancy/question-bank-add-new-qa-modal/question-bank-add-new-qa-modal.component.scss
// module chunks = main